import { Model } from '@/models/Model';
import { BackgroundEvent } from '@/support/CalendarDefaults';

export class Event extends Model
{
  protected $name: string = 'Event';
  protected $endpoint: string = '/events';
  protected $fillable: string[] = ['starts_at', 'ends_at', 'room', 'title', 'type', 'recurring'];

  public id?: string;
  public starts_at?: string;
  public ends_at?: string;
  public title?: string;
  public type?: string;
  public recurring?: Recurrence;

  get calendarEvent() {
    const parsedEvent: CalendarEvent = {
      id: this.id || '',
      title: this.title || '',
      start: this.starts_at || '',
      end: this.ends_at || '',
      extendedProps: {
        type: this.type,
      },
      editable: true,
      className: `${this.type}__event`,
    }
    return parsedEvent;
  }

  get backgroundEvent() {
    const parsedEvent: BackgroundEvent = {
      start: this.starts_at || '',
      end: this.ends_at || '',
      rendering: 'background',
    }
    return parsedEvent;
  }
}


// TODO: interface naar CalendarDefault
export interface CalendarEvent {
  id: string;
  title: string;
  start: string;
  end: string;
  editable?: boolean;
  className?: string;
  extendedProps?: object;
  constraint?: object;
}

export interface Recurrence {
  repeat_year?: string;
  repeat_month?: string;
  repeat_day?: string;
  repeat_week?: string;
  repeat_weekday?: string;
}
